const ons = {
    /**
     * Wait for the initial firebase auth change so that we can show the
     * "continue as..."/"im not..." buttons
     * @param container
     * @return {Promise<unknown>}
     */
    firebaseAuthStateChanged: container => {
        return new Promise(resolve => {
            container.listenToOnce(
                container.componentList.FirebaseStorage,
                'onFirebaseAuthStateChanged',
                () => resolve()
            );
        });
    }
};

const ifs = {
    noUser: (element, type, data, container, event) => {
        return !container.componentList.FirebaseStorage.check();
    },
};

const actions = {
    routerNext: (element, type, data, container, event) => {
        container.router.next();
    }
};

export default {
    render(data, event) {
        return document.createElement('div');
    },
    async postRender(element, type, data, container, event) {

        // Wait for an event if it is requested
        if (data.on) {
            await ons[data.on](container);
        }

        // Check if the action should run
        const result = ifs[data.if](element, type, data, container, event);

        Logger.info(
            `AUTORUN WILL${result ? '' : ' NOT'} RUN ${data.action}`,
            {element, type, data, container, event, result}
        );

        if (result) {
            actions[data.action](element, type, data, container, event);
        }
    },
};